import React from "react";
import { Play } from "lucide-react";
import Reveal from "../Reveal";

export default function Leadership() {
  return (
    <section
      id="leadership"
      data-testid="leadership-section"
      className="bg-[--kdm-bg-alt] py-28 lg:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12 items-center">
        {/* Image */}
        <Reveal className="lg:col-span-3">
          <div className="relative aspect-[4/5] overflow-hidden card-soft max-w-[260px] mx-auto lg:mx-0">
            <img
              src="https://customer-assets.emergentagent.com/job_kdm-web-portal/artifacts/ohmos02u_EJS%20ALAHAKOON.jpg"
              alt="Mr. E.J.S. Alahakoon — Founder & Chairman, KDM Group"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 inset-x-0 p-4 bg-gradient-to-t from-white via-white/80 to-transparent">
              <p className="overline">Founder & Chairman</p>
              <p className="font-serif text-base mt-1 text-[--kdm-ink]">Mr. Alahakoon</p>
            </div>
          </div>
        </Reveal>

        {/* Copy */}
        <div className="lg:col-span-9 lg:pl-8 space-y-8">
          <p className="overline">Leadership & Vision</p>
          <h2
            data-testid="leadership-heading"
            className="font-serif font-medium text-4xl lg:text-6xl leading-[1.02] tracking-tight"
          >
            A diplomatic bridge between
            <br />
            <span className="italic text-gold">Italian quality</span> & Sri Lankan growth.
          </h2>

          <a
            href="https://www.youtube.com/watch?v=PolrYGbdlyc"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="leadership-video-link"
            className="inline-flex items-center gap-3 group"
          >
            <span className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-[--kdm-ink] text-white transition-all duration-300 group-hover:bg-gold group-hover:scale-105">
              <Play size={16} fill="currentColor" className="ml-0.5" />
            </span>
            <span className="text-xs tracking-[0.22em] uppercase font-semibold text-[--kdm-ink] group-hover:text-gold transition-colors duration-300">
              Watch the Ada Derana 24 Interview
            </span>
          </a>

          <div className="space-y-6 max-w-xl">
            <Reveal>
              <p className="text-base text-[--kdm-ink] leading-relaxed">
                <span className="font-medium">Diplomatic Credentials.</span>{" "}
                Mr. Alahakoon has been officially nominated as the Sri Lankan B.I.O.
                (Bureau of International Organizations) Representative in Italy.
              </p>
            </Reveal>
            <Reveal delay={100}>
              <p className="text-base text-[--kdm-ink-soft] leading-relaxed">
                <span className="font-medium text-[--kdm-ink]">Technical Foundation.</span>{" "}
                A background in high-level telecommunications and IT — the driving force
                behind the group's digital transformation and the 15-year success of
                Anwarnet Pvt Ltd.
              </p>
            </Reveal>
            <Reveal delay={200}>
              <p className="text-base text-[--kdm-ink-soft] leading-relaxed">
                <span className="font-medium text-[--kdm-ink]">Strategic Bridge.</span>{" "}
                Under his leadership, the KCM Group has integrated Italian design and
                quality standards into Sri Lankan real estate, establishing Melissa's
                Riviera as a premier international asset.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
